module.exports = __webpack_public_path__ + "img/孟村管件.62fc0009.jpg";